import { Lock, LockOpen, Shield, ShieldAlert } from "lucide-react";

import { Badge } from "@/components/ui/badge";

type LockLevel = "platform" | "tenant" | "role" | "any" | string | undefined;

interface LockMeta {
  label: string;
  icon: JSX.Element;
  variant: "default" | "secondary" | "outline" | "destructive";
}

const ANY_META: LockMeta = {
  label: "Any layer",
  icon: <LockOpen className="size-3 mr-1" />,
  variant: "outline",
};

const META: Record<string, LockMeta> = {
  platform: {
    label: "Platform-locked",
    icon: <ShieldAlert className="size-3 mr-1" />,
    variant: "destructive",
  },
  tenant: {
    label: "Tenant-locked",
    icon: <Shield className="size-3 mr-1" />,
    variant: "default",
  },
  role: {
    label: "Role-locked",
    icon: <Lock className="size-3 mr-1" />,
    variant: "secondary",
  },
  any: ANY_META,
};

export function LockLevelBadge({ level }: { level?: LockLevel }): JSX.Element {
  const norm = level ?? "any";
  const meta: LockMeta = META[norm] ?? ANY_META;
  return (
    <Badge variant={meta.variant} className="text-[10px]">
      {meta.icon}
      {meta.label}
    </Badge>
  );
}
